import { Badge } from "@omni/ui/components/Badge/badge.component";
import { Button } from "@omni/ui/components/Button/button.component";
import { useMapped } from "@omni/utils/context/mapped.context";
import { cn } from "@omni/utils/styles";

import { usePaintConfiguratorContext } from "@/components/PaintConfigurator/context/paintConfigurator.context";

const StepIndicator = () => {
    const { currentStep, goToStep, steps } = usePaintConfiguratorContext();
    const { index } = useMapped();

    const step = steps.at(index);

    if (!step || !currentStep) return null;

    return (
        <Button
            color={"link"}
            className={cn(
                "tw:p-0 tw:flex tw:items-center",
                "tw:focus:no-underline",
                {
                    "tw:pointer-events-none": index === currentStep.index
                },
                "tw:not-last:after:mx-4 tw:not-last:after:h-px tw:not-last:after:w-8 tw:not-last:after:bg-grey-light"
            )}
            disabled={index > currentStep.index}
            onClick={() => goToStep(index)}
        >
            <div
                className={cn("tw:flex tw:flex-row tw:items-center tw:gap-2", {
                    "tw:opacity-40": index > currentStep.index
                })}
            >
                <Badge className={"tw:text-base tw:font-normal"}>
                    {index < currentStep.index ? (
                        <i className="las la-check"></i>
                    ) : (
                        index + 1
                    )}
                </Badge>
                <span
                    className={cn(
                        "tw:text-primary tw:font-normal tw:hidden tw:md:inline-block tw:transition-colors"
                    )}
                >
                    {step.meta.name}
                </span>
            </div>
        </Button>
    );
};

export { StepIndicator };
